import React from 'react'
import {useTranslation} from "react-i18next";
import SelectSearch from "@ui/select/selectSearch/SelectSearch";
import {IAccountItem} from "@containers/account/types";
import {ISelectBaseProps} from "@ui/select/types";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {
    useGetTasksTemplateSingleVoyageQuery
} from "@containers/singleVoyage/taskTemplate/queryHooks/useTaskTemplateSingleVoyageQuery";

interface IProps extends ISelectBaseProps<IAccountItem> {
    accountId: string | number
}

const SelectTaskTemplateSingleVoyage = ({
                                            value,
                                            onChange,
                                            width,
                                            setPage,
                                            disabled,
                                            label,
                                            error,
                                            errorMessage,
                                            accountId,
                                            ...rest
                                        }: IProps) => {

    const {t} = useTranslation()

    const {
        data,
        isLoading,
        isFetching,
        isError,
    } = useGetTasksTemplateSingleVoyageQuery({
        params: {
            accountId,
        }
    })
    const dataSelect = React.useMemo(() => {
        if (!data?.length) {
            return []
        }

        return data.map((item) => {
            const {id, name} = item;
            return {
                value: id?.toString(),
                label: name,
            }
        })
    }, [data])


    if (isLoading || isFetching) {
        return <SpinnerCustom variant={'relative'}/>
    }
    return (
        <SelectSearch
            {...rest}
            setPage={setPage}
            width={width}
            isError={isError}
            disabled={disabled}
            isLoading={isLoading || isFetching}
            value={value?.toString()}
            onChange={onChange}
            error={error}
            errorMessage={errorMessage}
            data={dataSelect}
            label={label ?? t('singleVoyage.taskTemplate')}
        />
    );
};

export default SelectTaskTemplateSingleVoyage;
